module.exports = {"320871001":"钵池街道","320871002":"徐杨街道","320871003":"南马厂街道","320871004":"枚乘街道","320871401":"新港","320871405":"金港路","320871410":"富城路","320871411":"福地路","320871412":"高铁商务区","320871420":"张码","320871421":"淮洪路"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320871.json
// module id = 1003
// module chunks = 0